import React, { useEffect } from 'react';
import { Box, useMediaQuery, useTheme, Grid } from '@mui/material';
import UnifiedLoginOptions from '../../../components/auth/UnifiedLoginOptions';
import { 
  EmailLoginForm, 
  EmojiLoginForm, 
  GoogleLoginForm, 
  MicrosoftLoginForm, 
  MyLoginForm 
} from '../../../components/auth/LoginForms';
import { iconlogin, loginStars } from '../../../components/assets/images';

const LoginPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [activeLoginMethod, setActiveLoginMethod] = React.useState(null);
  const [fadeState, setFadeState] = React.useState(true);
  const [transitionDuration, setTransitionDuration] = React.useState(300);

  const handleLoginMethodChange = (method) => {
    setFadeState(false);
    
    setTimeout(() => {
      setActiveLoginMethod(method);
      setFadeState(true);
    }, transitionDuration);
  };

  const handleBackToOptions = () => {
    setFadeState(false);
    
    setTimeout(() => {
      setActiveLoginMethod(null);
      setFadeState(true);
    }, transitionDuration);
  };

  const renderRightPanelContent = () => {
    return (
      <div className="contentArea">
        <Grid container justifyContent="center">
          {activeLoginMethod ? (
            <Grid item lg={11} md={11} sm={10} xs={12}>
              <Box 
                key={activeLoginMethod} 
                className="slideUpFadeIn"
              >
                {
                  {
                    'email': <EmailLoginForm onBackClick={handleBackToOptions} />,
                    'emoji': <EmojiLoginForm onBackClick={handleBackToOptions} />,
                    'google': <GoogleLoginForm onBackClick={handleBackToOptions} />,
                    'microsoft': <MicrosoftLoginForm onBackClick={handleBackToOptions} />,
                    'mylogin': <MyLoginForm onBackClick={handleBackToOptions} />
                  }[activeLoginMethod]
                }
              </Box>
            </Grid>
          ) : (
            <Grid item lg={5} md={5} sm={6} xs={12}>
              <div className="scaleIn">
                <UnifiedLoginOptions 
                  onLoginMethodChange={handleLoginMethodChange}
                />
              </div>
            </Grid>
          )}
        </Grid>
      </div>
    );
  };

    // Effect to adjust transition duration for mobile
  // useEffect(() => {
  //   setTransitionDuration(isMobile ? 200 : 300);
  // }, [isMobile]);

  return (
    <div className="login">
      <Grid container>
        {/* Left sidebar - always remains visible */}
        <Grid item lg={4} md={4} sm={12} xs={12}>
          <div className="brandSidebar">
            <h1 className="welcomeText">
              Welcome to <span>Welbee</span>
            </h1>
            
            <div className="welcomeDescription">
              Systematically measure and improve staff wellbeing
              across your School or Group
            </div>

            <div className="login-icon">
              <img src={iconlogin} alt="" />
            </div>
          </div>        
        </Grid>
        
        {/* Content area */}
        <Grid item lg={8} md={8} sm={12} xs={12}>          
          {renderRightPanelContent()}                  
        </Grid>
      </Grid>

      <div className="loginStars">
        <img src={loginStars} alt=""/>
      </div>
    </div>
  );
};

export default LoginPage;